// Compiled at 2026-09-18T12:45:23.821Z
export const $Permissions = {} as const;
